import ajax from '../../api/ajax'
const state = {
    location : {                                        // 定位信息
        lng: "",                                        // 经度
        lat: "",                                        // 纬度
        province: "",                                   // 定位的省份名称 如：北京市
        city: "",                                       // 定位的城市名称 如： 北京市
        country: "",                                    // 定位的城市名称 如： 海淀区
        address: "",                                    // 定位的详细地址
        bounds: null                                    // 地图显示的矩形范围
    },
    storeInfo: {                                        // 选中网点的信息
        lng: "",                                        // 经度
        lat: "",                                        // 纬度                                        
        province: '',
        city: '', 
        distinct: 0, 
        detail_addr: '', 
        name: '', 
        regcode: '', 
        key_prefix: ''
    }
}
const getters = {
    locLngLat(state) {                                  // 获取定位的经纬度
        let result = {}
        const { lng, lat } = state.location
        if (lng && lat) {
            result = {lng, lat}
        } else {
            result = JSON.parse(sessionStorage.getItem('OWF_STORE_MAP_LOCATION'))
        }
        return result
    },
    storeLngLat(state) {                                  // 获取网点的经纬度
        let result = {}
        const { lng, lat } = state.storeInfo
        if (lng && lat) {
            result = {lng, lat}
        } else {
            result = JSON.parse(sessionStorage.getItem('OWF_STORE_INFO'))
        }
        return result
    },
    storeInfo(state) {
        let result = {}
        if (state.storeInfo.name) {
            result = state.storeInfo
        } else {
            return JSON.parse(sessionStorage.getItem('OWF_STORE_INFO'))
        }
        return result
    },
    locationInfo(state) {                                // 获取网点定位的城市信息
        let result = {}
        const { province, city, country} = state.location
        if (province && city) {
            result = {city, province}
        } else {
            result = JSON.parse(sessionStorage.getItem('OWF_STORE_MAP_LOCATION'))
        }
        return result
    },
}
const mutations = {
    setLocation (state, item) {                         // 设置定位
        state.location = item
        sessionStorage.setItem('OWF_STORE_MAP_LOCATION', JSON.stringify(state.location))
    },
    setStoreInfo (state, item) {                        // 设置网点信息
        state.storeInfo = item
        sessionStorage.setItem('OWF_STORE_INFO', JSON.stringify(state.storeInfo))
    }
}
const actions = {}
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/storeMap.js